import { Button } from "@/components/ui/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog"

interface ConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title?: string
  message?: string
}

export function ConfirmationDialog({
  isOpen,
  onClose,
  onConfirm,
  title='Are you sure?',
  message='This action cannot be undone. Are you sure you want to proceed?',
}: ConfirmationDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>
        <DialogFooter className='div className=" flex justify-end items-center gap-3 mt-4 '>
          <Button variant="outline" onClick={onClose} className="w-[100px] text-black font-semibold">
            Cancel
          </Button>
          <Button onClick={onConfirm} className="w-[100px] text-black hover:bg-primary">
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

